import { SchmancyElement, schmancyElement } from "@mhmo91/schmancy/mixins";
import { html } from "lit";
import { LocalizeMixin } from "../i18n/localize.ts";
import {
	organizationSelection,
	selectOrganization$,
} from "./organization.state.ts";

@schmancyElement("organization-select")
export class OrganizationSelect extends LocalizeMixin(SchmancyElement) {
	override render() {
		const view = organizationSelection.get();
		return html`<div class="flex flex-col gap-2"><schmancy-select label=${this.t("admin.organizations.label")} .value=${view.organizationId ?? ""} ?disabled=${view.switching || view.status !== "ready"} @change=${(
			event: CustomEvent<{ value: string }>,
		) => {
			const value =
				typeof event.detail === "string" ? event.detail : event.detail.value;
			if (value && value !== view.organizationId)
				selectOrganization$.next(value);
		}}>${view.organizations.map((organization) => html`<schmancy-option .value=${organization.id}>${organization.brand.name}</schmancy-option>`)}</schmancy-select><p role="status" class="text-body-sm text-error-default min-h-6">${view.error}</p></div>`;
	}
}
declare global {
	interface HTMLElementTagNameMap {
		"organization-select": OrganizationSelect;
	}
}
